import React from "react";
import moment from "moment";
import { DatePicker } from "antd";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import "antd/dist/antd.css";

import style from "../../assets/jss/disal-main/Layouts/Report";
import { useReport } from "../../Context/ReportContext";

const today = moment();

const ReportContent = ({ classes }) => {
  const {
    dailyStartDate,
    successMessage,
    setDailyStartDate,
    setRangeStartDate,
    setRangeEndDate,
    setIncidentStartDate,
    setIncidentEndDate,
    setStockStartDate,
    setWarehouseStartDate,
    setWarehouseEndDate,
    handleDownloadReport,
  } = useReport();

  const handleDailyStartChange = (date) => {
    setDailyStartDate(moment(date));
  };

  const handleRangeStartChange = (date) => {
    setRangeStartDate(moment(date));
  };

  const handleRangeEndChange = (date) => {
    setRangeEndDate(moment(date));
  };

  const handleIncidentStartChange = (date) => {
    setIncidentStartDate(moment(date));
  };

  const handleIncidentEndChange = (date) => {
    setIncidentEndDate(moment(date));
  };

  const handleStockStartChange = (date) => {
    setStockStartDate(moment(date));
  };

  const handleWarehouseStartChange = (date) => {
    setWarehouseStartDate(moment(date));
  };

  const handleWarehouseEndChange = (date) => {
    setWarehouseEndDate(moment(date));
  };

  return (
    <div className={classes.reportContent}>
      <section className="report">
        <Grid container>
          <Grid item md={12} className={classes.boxReport}>
            <h4>Reporte diario</h4>
            <Grid container>
              <Grid
                item
                sm={12}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Grid item sm={3}>
                  <div className={classes.groupInput}>
                    <label htmlFor="report2">Fecha:</label>
                    <DatePicker
                      defaultValue={dailyStartDate}
                      disabledDate={(current) =>
                        current && current >= moment().subtract(1, 'days').endOf("day")
                      }
                      onChange={handleDailyStartChange}
                      size="large"
                      className="header-select"
                      placeholder="Fecha"
                      format="DD/MM/YYYY"
                      style={{ width: 150, marginRight: 40 }}
                    />
                  </div>
                </Grid>
                <Grid item sm={3}>
                <button type="button" onClick={() => handleDownloadReport('daily')}>
                  Descargar
                </button>
              </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12} className={classes.boxReport}>
            <h4>Reporte acumulado por punto de acopio</h4>
            <Grid container>
              <Grid
                item
                sm={3}
                style={{ display: "flex", alignItems: "center" }}
              >
                <div className={classes.groupInput}>
                  <label htmlFor="report1">Desde:</label>
                  <DatePicker
                    defaultValue={moment(today, "DD/MM/YYYY")}
                    disabledDate={(current) =>
                      current && current >= moment().endOf("day")
                    }
                    onChange={handleRangeStartChange}
                    size="large"
                    className="header-select"
                    placeholder="Desde"
                    format="DD/MM/YYYY"
                    style={{ width: 150, marginRight: 40 }}
                  />
                </div>
              </Grid>
              <Grid
                item
                sm={3}
                style={{ display: "flex", alignItems: "center" }}
              >
                <div className={classes.groupInput}>
                  <label htmlFor="report2">Hasta:</label>
                  <DatePicker
                    disabledDate={(current) =>
                      current && current >= moment().endOf("day")
                    }
                    defaultValue={moment(today, "DD/MM/YYYY")}
                    onChange={handleRangeEndChange}
                    size="large"
                    className="header-select"
                    placeholder="Desde"
                    format="DD/MM/YYYY"
                    style={{ width: 150, marginRight: 40 }}
                  />
                </div>
              </Grid>
              <Grid item sm={3}>
                <button type="button" onClick={() => handleDownloadReport('collectionPoints')}>
                  Descargar
                </button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12} className={classes.boxReport}>
            <h4>Reporte de incidencias</h4>
            <Grid container>
              <Grid
                item
                sm={3}
                style={{ display: "flex", alignItems: "center" }}
              >
                <div className={classes.groupInput}>
                  <label htmlFor="report1">Desde:</label>

                  <DatePicker
                    defaultValue={moment(today, "DD/MM/YYYY")}
                    onChange={handleIncidentStartChange}
                    size="large"
                    className="header-select"
                    placeholder="Desde"
                    format="DD/MM/YYYY"
                    style={{ width: 150, marginRight: 40 }}
                  />
                </div>
              </Grid>
              <Grid
                item
                sm={3}
                style={{ display: "flex", alignItems: "center" }}
              >
                <div className={classes.groupInput}>
                  <label htmlFor="report2">Hasta:</label>
                  <DatePicker
                    defaultValue={moment(today, "DD/MM/YYYY")}
                    onChange={handleIncidentEndChange}
                    size="large"
                    className="header-select"
                    placeholder="Desde"
                    format="DD/MM/YYYY"
                    style={{ width: 150, marginRight: 40 }}
                  />
                </div>
              </Grid>
              <Grid item sm={3}>
                <button
                  type="button"
                  onClick={() => handleDownloadReport('incidents')}
                >
                  Descargar
                </button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={12} className={classes.boxReport}>
            <h4>Reporte de stock</h4>
            <Grid container>
              <Grid item sm={6}
                style={{ display: "flex", alignItems: "center" }}
              >
                <div className={classes.groupInput}>
                  <label htmlFor="report1">Fecha:</label>

                    <DatePicker
                      defaultValue={moment(today, "DD/MM/YYYY")}
                      onChange={handleStockStartChange}
                      size="large"
                      className="header-select"
                      placeholder="Desde"
                      format="DD/MM/YYYY"
                      style={{ width: 150, marginRight: 40 }}
                    />
                  </div>
                </Grid>

              <Grid item sm={6}>
                <button type="button" onClick={() => handleDownloadReport('stock')}>
                  Descargar
                </button>
              </Grid>
            </Grid>
          </Grid>
          
          <Grid item md={12} className={classes.boxReport}>
            <h4>Reporte de patios temporales</h4>
            <Grid container>
              <Grid container item sm={6}>
                <Grid item sm={6}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div className={classes.groupInput}>
                    <label htmlFor="report1">Desde:</label>

                    <DatePicker
                      defaultValue={moment(today, "DD/MM/YYYY")}
                      onChange={handleWarehouseStartChange}
                      size="large"
                      className="header-select"
                      placeholder="Desde"
                      format="DD/MM/YYYY"
                      style={{ width: 150, marginRight: 40 }}
                    />
                  </div>
                </Grid>
                <Grid item sm={6}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div className={classes.groupInput}>
                    <label htmlFor="report2">Hasta:</label>
                    <DatePicker
                      defaultValue={moment(today, "DD/MM/YYYY")}
                      onChange={handleWarehouseEndChange}
                      size="large"
                      className="header-select"
                      placeholder="Desde"
                      format="DD/MM/YYYY"
                      style={{ width: 150, marginRight: 40 }}
                    />
                  </div>
                </Grid>
              </Grid>
              <Grid item sm={4}>
                  <button
                    type="button"
                    onClick={() => handleDownloadReport('warehouse')}
                  >
                    Descargar
                  </button>
              </Grid>
            </Grid>
          </Grid>
          
          <p className={classes.message}>
            {successMessage && "El reporte se ha descargado con éxito"}
          </p>
        </Grid>
      </section>
    </div>
  );
};

export default withStyles(style)(ReportContent);
